// extracted by mini-css-extract-plugin
export default {"wrapper":"W_SignContainer_wrapper__F7wUz"};